import React from 'react'
import Index from './pages/Index'
import Printers from './pages/Printers'
import Solutions from './pages/Solutions'
import SmartCards from './pages/SmartCards'
import Accessories from './pages/Accessories'
import Contact from './pages/Contact'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import OffcanvasMenu from './components/OffcanvasMenu'

import ScrollToTop from './components/ScrollToTop'

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div>
        <Header />
        <OffcanvasMenu />
        <Routes>
          <Route path='/' element={<Index />} />
          <Route path='/printers' element={<Printers />} />
          <Route path='/solutions' element={<Solutions />} />
          <Route path='/smart-cards' element={<SmartCards />} />
          <Route path='/accessories' element={<Accessories />} />
          <Route path='/contact' element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App